/* global axios */
import ApiClient from '../ApiClient';

// `type` is the survey type the flow belongs to ('csat' or 'nps'); the backend
// pins it through the route, so each type keeps its own flow id.
class WhatsappFlowsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  flowUrl(inboxId, type) {
    return `${this.url}/${inboxId}/whatsapp_flows/${type}`;
  }

  getFlowStatus(inboxId, type = 'csat') {
    return axios.get(this.flowUrl(inboxId, type));
  }

  createFlow(inboxId, type = 'csat') {
    return axios.post(this.flowUrl(inboxId, type));
  }

  toggleFlow(inboxId, enabled, type = 'csat') {
    return axios.put(this.flowUrl(inboxId, type), { enabled });
  }

  deleteFlow(inboxId, type = 'csat') {
    return axios.delete(this.flowUrl(inboxId, type));
  }
}

export default new WhatsappFlowsAPI();
